import React, { useMemo } from "react";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import { Doughnut } from "react-chartjs-2";
import ExpandableStats from "components/ExpandableStats";
import ParkkiTheme from "themes/ParkkiTheme";
import MapConfig from "services/map/MapConfig";

const StatsContainer = styled.div`
    display: flex;
    flex: 1,
    justify-content: center;
    width: 100%;
    flex-direction: column;
    margin-top: ${ParkkiTheme.spacings.xsmall};
`;

function AreaDoughnutLayout({
  disabled,
  stats,
  inOutDistributionByPercentage,
}) {
  const data = useMemo(() => {
    return stats.reduce((result, currentStat) => {
      return {
        ...result,
        labels: [...(result.labels ?? []), currentStat.long_name ?? ""],
        datasets: [
          {
            ...(result.datasets?.[0] ?? {}),
            data: [
              ...(result.datasets?.[0]?.data ?? []),
              currentStat.totalMouvements.value || 0,
            ],
            backgroundColor: [
              ...(result.datasets?.[0].backgroundColor ?? []),
              currentStat.options.selection_color ??
                MapConfig.flow.point.fillColor.selected ??
                "#69A73B",
            ],
          },
        ],
      };
    }, {});
  }, [stats]);

  const options = useMemo(() => {
    return {
      legend: {
        display: false,
      },
      tooltips: {
        callbacks: {
          label: (tooltipItem, data) => {
            const dataset = data.datasets[0];

            const tooltipItemIndex = tooltipItem.index;

            const value = dataset.data[tooltipItemIndex];

            const label = data.labels[tooltipItemIndex];
            const percentage = Math.round(
              (value / dataset._meta[Object.keys(dataset?._meta)?.[0]].total) *
                100
            );

            return inOutDistributionByPercentage
              ? ` ${label} : ${percentage || 0} %`
              : ` ${label} : ${value || 0}`;
          },
          afterLabel: () => "",
        },
      },
      responsive: true,
      maintainAspectRatio: true,
    };
  }, [inOutDistributionByPercentage]);

  function handleELementsClick() {}

  return (
    <>
      <Doughnut
        data={data}
        options={options}
        onElementsClick={handleELementsClick}
      />
      <StatsContainer>
        {stats.map((stat, index) => (
          <ExpandableStats
            disabled={disabled}
            key={stat?.id || index}
            stats={stat}
            byPercentage={inOutDistributionByPercentage}
          />
        ))}
      </StatsContainer>
    </>
  );
}

AreaDoughnutLayout.defaultProps = {
  stats: [],
};

const mapStateToProps = (state) => ({
  inOutDistributionByPercentage:
    state?.Flow.filters.inOutDistributionByPercentage,
});

export default connect(mapStateToProps)(AreaDoughnutLayout);
